import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Link } from "react-router-dom";
import { AppProvider } from "@/context/AppContext";
import { Toaster } from "@/components/ui/sonner";
import { BrandIntro } from "@/components/BrandIntro";
import { Layout } from "@/components/Layout";
import Home from "@/pages/Home";
import Living from "@/pages/Living";
import Invests from "@/pages/Invests";
import Luxe from "@/pages/Luxe";
import Properties from "@/pages/Properties";
import PropertyDetail from "@/pages/PropertyDetail";
import Compare from "@/pages/Compare";
import Request from "@/pages/Request";
import About from "@/pages/About";
import Contact from "@/pages/Contact";
import Blog from "@/pages/Blog";
import BlogPost from "@/pages/BlogPost";
import Admin from "@/pages/Admin";

const NotFound = () => (
  <div className="container-arch flex min-h-[80vh] flex-col items-center justify-center pt-24 text-center">
    <div className="overline">404</div>
    <h1 className="mt-3 font-serif text-5xl font-light text-[var(--text-primary)]">This perspective doesn't exist.</h1>
    <Link to="/" className="btn-gold mt-8">Back to Home</Link>
  </div>
);

function App() {
  return (
    <AppProvider>
      <BrowserRouter>
        <BrandIntro />
        <Toaster position="top-right" richColors closeButton />
        <Routes>
          <Route element={<Layout />}>
            <Route path="/" element={<Home />} />
            <Route path="/living" element={<Living />} />
            <Route path="/invests" element={<Invests />} />
            <Route path="/luxe" element={<Luxe />} />
            <Route path="/properties" element={<Properties />} />
            <Route path="/properties/:id" element={<PropertyDetail />} />
            <Route path="/compare" element={<Compare />} />
            <Route path="/request" element={<Request />} />
            <Route path="/about" element={<About />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/blog" element={<Blog />} />
            <Route path="/blog/:slug" element={<BlogPost />} />
            <Route path="*" element={<NotFound />} />
          </Route>
          <Route path="/nimda" element={<Admin />} />
        </Routes>
      </BrowserRouter>
    </AppProvider>
  );
}

export default App;
